import { ActivatedRoute, Router } from '@angular/router';
import { Injectable, NgZone } from '@angular/core';

import { MainService } from './main.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class SecurityService {
  param_jwt: any;
  module_index: any;
  hostWithReturnUrls: any;
  currentOrigin: any;
  fpath: any;
  constructor(private router: Router, private mainSVC: MainService, public zone: NgZone) { }

  async isAuthenticated() {
    this.hostWithReturnUrls = this.mainSVC.hostWithReturnUrl;
    this.currentOrigin = location.protocol + '//' + location.hostname;
    console.table(this.hostWithReturnUrls);
    this.getHostFpath();
    const urlSearchParams = new URLSearchParams(window.location.search);
    this.param_jwt = urlSearchParams.get('id');
    this.module_index = urlSearchParams.get('fpath');

    if (this.param_jwt == undefined || this.param_jwt == null) {
      if (
        sessionStorage.getItem('svm_jwt') == undefined ||
        sessionStorage.getItem('svm_jwt') == null
      ) {
        this.router.navigate(['/login']);
      } else {
        this.router.navigate(['./' + this.fpath]);
      }
    } else {
      var obj = { jwt: this.param_jwt };

      var resp = await this.mainSVC.verfiyTokens(obj);

      if (resp['error'] == false) {
        sessionStorage.setItem('erpUser', JSON.stringify(resp['erpUser']));
        sessionStorage.setItem('svm_jwt', JSON.stringify(resp['jwt']));

        if (this.module_index == undefined || this.module_index == null) {
          this.router.navigate(['./' + this.fpath]);
        } else {
          if (resp['erpUser']['b_acct_id'] == 0) {
            this.router.navigate(['./' + this.module_index]);
          } else {
            this.router.navigate(['./' + this.module_index]);
          }
        }
      } else {
        Swal.fire('Error...', resp['message'], 'error');
        this.router.navigate(['/login']);
      }
    }
  }

  getHostFpath() {
    for (const hostapp of this.hostWithReturnUrls) {
      if (this.currentOrigin == hostapp['host']) {
        this.fpath = hostapp['fpath'];
      }
    }
  }
  
  //////////////////////////////////////////////////getAllList////////////////////////////////////////////
  async getAuthorisedListFor(type: string) {
    switch (type) {
      case "acct":
        await this.getAllAccounts()
        break;
      case "role":
        await this.getAllRoles()
        break;
      case "mod":
        await this.AllModules()
        break;
      case "comp":
        await this.AllComponents()
        break;
      case "sol":
        await this.AllSolution()
        break;
      case "role-sol":
        await this.getRolesbySoln()
        break;

      default:
        Swal.fire('Error...', 'some error', 'error');

    }

  }
  //////////////////////////////////////////////////Princy's Code///////////////////////////////////////////////////////////////
  accountlist = []
  audit_info_obj = {}

  async getAllAccounts() {
    let authObj: any = new Object()
    let erpUser = JSON.parse(sessionStorage.getItem('erpUser'));
    authObj['le_id'] = erpUser['le_id']
    authObj['identity_id'] = erpUser['identity_id']
    authObj['status_cd'] = 'AC'
    var resp = await this.mainSVC.getAllAccounts(authObj);
    console.log(resp);
    if (resp['error'] == false ) {

      this.accountlist = resp['data'];
      for (let i = 0; i < this.accountlist.length; i++) {
        this.accountlist[i]['acct_desc'] =
          this.accountlist[i]['b_acct_id'] +
          ' - ' +
          this.accountlist[i]['account_name'];
      }
      if (resp['data'].length > 1) {
        await this.selectMultiAccount();
      } else if(resp['data'].length==1) {
        await this.selectOneAccount();
      }
      else{
          console.log('no Account');
          await this.mainSVC.finalSubmit(erpUser)

          
      }
    }
    else if (resp['data'].length == 0) {
      this.audit_info_obj['status'] = 'FAIL';
      this.audit_info_obj['user_id'] = '';
      this.audit_info_obj['message'] = 'You do not have Access to Any Account';
      await this.mainSVC.audit_insert(this.audit_info_obj);
      Swal.fire('Error', 'Failed', 'error');
    } else {
      this.audit_info_obj['status'] = 'FAIL';
      this.audit_info_obj['user_id'] = '';
      this.audit_info_obj['message'] = resp['data'];
      Swal.fire('Error...', resp['data'], 'error');
      await this.mainSVC.audit_insert(this.audit_info_obj);
    }

  }
  selectedaccount = {}
  b_acct_id: any
  async selectOneAccount() {
    this.selectedaccount = this.accountlist[0];
    this.b_acct_id = this.accountlist[0].b_acct_id;
    await this.SubmitAccount();
  }

  async selectMultiAccount() {
    this.zone.run(() => {
      this.router.navigate(['/multi-account']);
    });
  
  }
  async SubmitAccount() {
    let erpUser = JSON.parse(sessionStorage.getItem('erpUser'));
    erpUser['account_name'] = this.selectedaccount?.['account_name'];
    erpUser['account_short_name'] = this.selectedaccount?.['account_short_name'];
    erpUser['acct_cd'] = this.selectedaccount?.['account_short_name'];
    erpUser['acct_desc'] = this.selectedaccount?.['acct_desc'];
    erpUser['address'] = this.selectedaccount?.['address'];
    erpUser['b_acct_id'] = 1 * (this.selectedaccount?.['b_acct_id']);
    await this.mainSVC.finalSubmit(erpUser)
  }
  changeaccount(b_acct_id: any) {
    console.log(b_acct_id);

    for (var i = 0; i < this.accountlist.length; i++) {
      if (this.accountlist[i]['b_acct_id'] == b_acct_id) {
        this.selectedaccount = this.accountlist[i];


      }
    }
    console.log(this.selectedaccount);

  }
  rolesArr = []
  roles_code_arr = []
  async getAllRoles() {
    this.roles_code_arr = []
    this.rolesArr = []
    let authObj: any = new Object()
    let erpUser = JSON.parse(sessionStorage.getItem('erpUser'));
    authObj['identity_id'] = erpUser['identity_id']
    authObj['status_cd'] = 'AC'
    if (erpUser['acct_cd'] != null && erpUser['acct_cd'] != undefined && erpUser['acct_cd'] != "")
      authObj['acct_id'] = erpUser['acct_cd']
    var resp = await this.mainSVC.getAllroles(authObj);
    console.log(resp);
    if (resp['error'] == false ) {
      this.rolesArr = resp['data']
      this.rolesArr.forEach((item) => {
        this.roles_code_arr.push(item['role_cd'])


      });

    }
    else {

      Swal.fire('Error...', resp['data'], 'error');

    }
    await this.submitRoles()

  }
  async submitRoles() {
    let erpUser = JSON.parse(sessionStorage.getItem('erpUser'));
    erpUser['role_cd'] = this.roles_code_arr
    erpUser['roles_permission'] = this.rolesArr
    await this.mainSVC.finalSubmit(erpUser)

  }
  async AllModules() {
    this.modulesarr = []
    this.modulesprevarr = []
    let erpUser = JSON.parse(sessionStorage.getItem('erpUser'));
    let rolesarr = erpUser['roles_permission']
    let authObj: any = new Object()

    authObj['status_cd'] = 'AC'
    // rolesarr.forEach(async (item) => {
    //   authObj['leaf_cd'] = item['res_type_hr_cd']
    //   await this.getAllModules(authObj)


    // });
    for (let i = 0; i < rolesarr.length; i++) {
      if (rolesarr[i]['authorization'] == 'GRANT') {
        authObj['leaf_cd'] = rolesarr[i]['res_type_hr_cd']
        await this.getAllModules(authObj)

      }
    }
    await this.submitModules()






  }
  modulesarr = []
  modulesprevarr = []
  async getAllModules(authObj) {

    var resp = await this.mainSVC.getAllmodules(authObj);
    console.log(resp);
    if (resp['error'] == false ) {
      this.modulesprevarr.push(resp['data'])


    }
    else {

      Swal.fire('Error...', resp['data'], 'error');

    }
    // await this.submitModules()



  }
  async submitModules() {
    let erpUser = JSON.parse(sessionStorage.getItem('erpUser'));
    let unique = this.modulesprevarr.flat(1)
    this.modulesarr = unique.filter((item, i, ar) => ar.indexOf(item) === i);

    console.log(this.modulesarr, this.modulesprevarr)
    erpUser['module_cd'] = this.modulesarr
    erpUser['assigned_product_cd'] = this.modulesarr
    await this.mainSVC.finalSubmit(erpUser)

  }
  /////////////////////////////////////component//////////////////////////////////
  roleObj
  async AllComponents() {
    this.comparr = []
    this.comparrprevarr = []
    this.per_arr = []
    let erpUser = JSON.parse(sessionStorage.getItem('erpUser'));
    let rolesarr = erpUser['roles_permission']
    let authObj: any = new Object()
    authObj['status_cd'] = 'AC'

    for (let i = 0; i < rolesarr.length; i++) {
      if (rolesarr[i]['authorization'] == 'GRANT') {
        this.roleObj = {}
        authObj['leaf_cd'] = rolesarr[i]['res_type_hr_cd']
        this.roleObj = rolesarr[i]
        await this.getAllComponents(authObj)

      }

    }
    await this.submitComponents()
  }
  comparr = []
  comparrprevarr = []
  per_arr = []
  async getAllComponents(authObj) {

    var resp = await this.mainSVC.getAllComponents(authObj);
    console.log(resp);
    if (resp['error'] == false ) {
      this.comparrprevarr.push(resp['data'])


      for (let i = 0; i < resp['data'].length; i++) {
        let per_obj = new Object()
        per_obj['authorization'] = this.roleObj['authorization']
        per_obj['pr_gp_sid'] = this.roleObj['pr_gp_sid']

        per_obj['comp_cd'] = resp['data'][i]
        this.per_arr.push(per_obj)

      }


    }
    else {

      Swal.fire('Error...', resp['data'], 'error');

    }
  }
  async submitComponents() {
    let erpUser = JSON.parse(sessionStorage.getItem('erpUser'));
    let unique = this.comparrprevarr.flat(1)
    this.comparr = unique.filter((item, i, ar) => ar.indexOf(item) === i);


    this.uniqTransform(this.per_arr, 'comp_cd', (a, b) => a.pr_gp_sid = Math.max(a.pr_gp_sid, b.pr_gp_sid));
    console.log(this.comparr, this.comparrprevarr)
    erpUser['assigned_component'] = this.comparr
    erpUser['assigned_component_permission'] = this.per_arr
    console.log('auth')

    await this.mainSVC.finalSubmit(erpUser)

  }
  ///////////////////////////////Solution////////////////////////////////////
  async AllSolution() {
    this.modulesarr = []
    this.modulesprevarr = []
    let erpUser = JSON.parse(sessionStorage.getItem('erpUser'));
    let rolesarr = erpUser['roles_permission']
    let authObj: any = new Object()
    authObj['status_cd'] = 'AC'

    for (let i = 0; i < rolesarr.length; i++) {
      authObj['leaf_cd'] = rolesarr[i]['res_type_hr_cd']
      await this.getAllSolution(authObj)

    }
    await this.submitSolution()
  }
  solarr = []
  solprevarr = []
  async getAllSolution(authObj) {

    var resp = await this.mainSVC.getAllSolution(authObj);
    console.log(resp);
    if (resp['error'] == false ) {
      this.solprevarr.push(resp['data'])
    }
    else {
      Swal.fire('Error...', resp['data'], 'error');

    }
  }
  async submitSolution() {
    let erpUser = JSON.parse(sessionStorage.getItem('erpUser'));
    let unique = this.solprevarr.flat(1)
    this.solarr = unique.filter((item, i, ar) => ar.indexOf(item) === i);

    console.log(this.solarr, this.modulesprevarr)
    erpUser['sol_cd'] = this.solarr

    await this.mainSVC.finalSubmit(erpUser)

  }
  // uniqTransform(arr: any, prop: any, combine: any) {
  //   return arr.filter((elt: any) => {
  //     const previous = arr.find(e2 => e2[prop] === elt[prop]);
  //     if (previous === elt) return true;
  //     combine(previous, elt);
  //   });






  // }
  uniqTransform(arr: any[], prop: string, combine: (prev: any, curr: any) => void): any[] {
    const seen = new Set();
    
    return arr.filter((elt: any) => {
      const key = elt[prop];
      if (seen.has(key)) {
  
        const previous = arr.find(e2 => e2[prop] === elt[prop]);
        if (previous) combine(previous, elt);
        return false; 
      } else {
        seen.add(key);
        return true; 
      }
    });
  }
  
  async getRolesbySoln() {
    this.roles_code_arr = []
    this.rolesArr = []
    let authObj: any = new Object()
    let erpUser = JSON.parse(sessionStorage.getItem('erpUser'));
    authObj['identity_id'] = erpUser['identity_id']
    authObj['status_cd'] = 'AC'
    let sol_cd = null
    if (erpUser['sol_cd'] != null && erpUser['sol_cd'] != undefined && erpUser['sol_cd'] != "")
      sol_cd = erpUser['sol_cd']
    var resp = await this.mainSVC.getAllrolesbysoln(authObj);
    console.log(resp);
    if (resp['error'] == false) {
         if(resp['data'].length > 0){
          let rolesarr = resp['data']
          for (let i = 0; i < rolesarr.length; i++) {
            if (rolesarr[i]['authorization'] == 'GRANT') {
              let roleObj = new Object()
              roleObj['status_cd'] = 'AC'
              roleObj['sol_cd'] = sol_cd
              roleObj['leaf_cd'] = rolesarr[i]['res_type_hr_cd']
              let result = await this.isrolebysol(roleObj)
              console.log(result, 'iscomp');
              if (result) {
    
    
    
                this.rolesArr.push(rolesarr[i])
                this.roles_code_arr.push(rolesarr[i]['role_cd'])
    
    
              }
            }
    
    
          }

         }
   


    }
    else {

      Swal.fire('Error...', resp['data'], 'error');

    }
    await this.submitRoles()

  }
  async isrolebysol(authObj) {
    var resp = await this.mainSVC.isrolebysoln(authObj);
    console.log(resp)
    if (resp['error'] == false) {
      return resp['data']


    }
    else {
      Swal.fire('Error...', resp['data'], 'error');

      return false

    }

  }

  /////////////////////////////////isAuthorisedFor/////////////////////
  async isAuthorisedFor(type: string, value: any) {
    switch (type) {
      case "acct":
        return this.isAuthorisedforacct(value)

      // case "role":
      //   await this.getAllRoles()
      //   break;
      // case "mod":
      //   await this.AllModules()
      //   break;
      case "comp":
        return this.isAuthorisedforcomp(value)

      // case "sol":
      //   await this.AllSolution()
      //   break;

      default:
        Swal.fire('Error...', 'some error', 'error');

    }

  }
  async isAuthorisedforcomp(value) {
    let erpUser = JSON.parse(sessionStorage.getItem('erpUser'));
    let rolesarr = erpUser['roles_permission']
    let authObj: any = new Object()
    authObj['status_cd'] = 'AC'
    authObj['comp_cd'] = value
    let ret_flag = false

    for (let i = 0; i < rolesarr.length; i++) {
      if (rolesarr[i]['authorization'] == 'GRANT') {
        this.roleObj = {}
        authObj['leaf_cd'] = rolesarr[i]['res_type_hr_cd']
        this.roleObj = rolesarr[i]
        let result = await this.iscomp(authObj)
        console.log(result, 'iscomp');
        if (result) {


          ret_flag = true
          break
        }
      }


    }
    return ret_flag
  }
  async iscomp(authObj) {
    var resp = await this.mainSVC.isAuthorisedforcomp(authObj);
    console.log(resp)
    if (resp['error'] == false) {
      return resp['data']


    }
    else {
      Swal.fire('Error...', resp['data'], 'error');

      return false

    }

  }
  async isAuthorisedforacct(value) {
    let authObj: any = new Object()
    let erpUser = JSON.parse(sessionStorage.getItem('erpUser'));
    authObj['le_id'] = erpUser['le_id']
    authObj['identity_id'] = erpUser['identity_id']
    authObj['acct_cd'] = value
    authObj['status_cd'] = 'AC'
    var resp = await this.mainSVC.isAuthorisedforacct(authObj);
    console.log(resp);
    if (resp['error'] == false) {
      return resp['data']


    }
    else {
      Swal.fire('Error...', resp['data'], 'error');

      return false

    }

  }
  async getSubscription() {
    let authObj: any = new Object()
    let erpUser = JSON.parse(sessionStorage.getItem('erpUser'));
    authObj['le_id'] = erpUser['le_id']
   
    var resp = await this.mainSVC.getSubscription(authObj);
    console.log(resp);
    if (resp['error'] == false) {
      console.log('done')
      Swal.fire('Success...', 'Subscribed Successfully', 'success');
      this.router.navigate(['./home']);
    
    


    }
    else {
      Swal.fire('Error...', resp['data'], 'error');

      

    }

  }
}



